<template>
    <v-card height="100%">
        <v-card-text class="pa-4">
            <v-layout row>
                <v-flex xs12 class="mb-12 mt-6 text-center">
                    <div class="headline">
                        {{ displayName }}
                    </div>
                    <div class="subheading">
                        Based out of {{ employee.location.location }}
                    </div>
                </v-flex>
            </v-layout>
            <v-simple-table dense class="mb-12">
                <thead>
                    <tr>
                        <th class="text-left" colspan="2">
                            Employee Info
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="width: 5%"><strong>Full Name:</strong></td>
                        <td class="employee-detail__displayedFullName">
                            {{ displayName }}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Location:</strong></td>
                        <td class="employee-detail__displayedLocation">
                            {{ employee.location.location }}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Email:</strong></td>
                        <td class="employee-detail__displayedEmail">
                            {{ employee.email }}
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-card-text>
        <v-card-actions class="justify-center pa-6">
            <v-btn class="print-button" color="primary" @click="print"
                ><v-icon class="mr-4">print</v-icon>Print</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'EmployeeDetail',
    props: {
        employee: {
            type: Object,
            required: true,
            default: () => ({
                uid: '',
                fbUid: '',
                firstName: '',
                lastName: '',
                email: '',
                location: {
                    uid: '',
                    location: ''
                }
            })
        }
    },
    computed: {
        displayName() {
            return this.employee.firstName + ' ' + this.employee.lastName;
        }
    },
    methods: {
        print() {
            document.body.classList.add('print-invoice');
            setTimeout(() => {
                print();
                document.body.classList.remove('print-invoice');
            });
        }
    }
};
</script>

<style scoped>
thead th {
    background: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid #ccc;
    white-space: normal;
}
th {
    padding: 0.3rem 1rem !important;
    text-align: left;
    height: 40px;
}
tr:hover {
    background: none !important;
}
</style>

<style>
.print-invoice .application {
    background: none;
}
.print-invoice aside,
.print-invoice .v-tabs-bar,
.print-invoice .print-button,
.print-invoice .edit-invoice-button,
.print-invoice .v-navigation-drawer,
.print-invoice .page-header,
.print-invoice .no-print-col,
.print-invoice .v-footer {
    display: none !important;
}
.print-invoice .offset-left {
    margin-left: 16.6666666667%;
}
.print-invoice .container,
.print-invoice .v-container,
.print-invoice .v-content {
    padding: 0 !important;
    max-width: none;
    background: white !important;
}
.print-invoice div {
    border: none;
    box-shadow: none;
}

.print-invoice .print-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
}
</style>
